class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });

          // custom safegaurd functionality code
              
            //   var safeguardInCart = false;
            // //console.log('safeguardInCart 0: ',safeguardInCart);
            // {% if safeguard_in_cart_lq_check %}
            //   safeguardInCart = true;
            //   //console.log('safeguardInCart inif: ',safeguardInCart);
            // {% else %}
            //   safeguardInCart = false;                            
            //   //console.log('safeguardInCart inelse: ',safeguardInCart);
            // {% endif %}
          
            
          // document.addEventListener('DOMContentLoaded', function(){
          setTimeout(function(){
            
            //console.log('inside renderContents');
            
            let checkBox = document.querySelector(".check-box");
            let safeguardBox = document.querySelector(".shipping-guard");
            let cross = document.querySelector(".guard-cross");
          
            function checkSafeguardStatus(checkBox){
               if (!checkBox) {
                return;
              }
                  const safeguardPrice = parseFloat(checkBox.dataset.price);
                  let currentPriceText = document.querySelector(".totals__total-value").textContent;
                  const currency = currentPriceText.replace(/[0-9.,\s]/g, '');
                  let currentPriceVal;
                  let updatedPrice;
                  currentPriceVal = currentPriceText.replace(/[^\d,.]/g, '');
              
                  if (currentPriceVal.includes('.')) {
                    currentPriceVal = currentPriceVal.replace(',','');
                  }
                  currentPriceVal = parseFloat(currentPriceVal.replace(',','.'));
              
              if(checkBox.checked == true){
              
                  if(safeguardBox){
                    safeguardBox.style.display = "flex"; 
                  } 
                    //increment price
                    updatedPrice = currentPriceVal + safeguardPrice;
           
                }else{
                    if(safeguardBox){
                    safeguardBox.style.display = "none"; 
                  }
                    //decrement price     
                   updatedPrice = currentPriceVal - safeguardPrice;       
                }
              updatedPrice = updatedPrice.toFixed(2);
               document.querySelector(".totals__total-value").textContent = (`${ currency }${ updatedPrice } `).replace('.', ',');
               if (typeof window.Shopify !== 'undefined' && Shopify.hasOwnProperty('currency')) {
                 document.querySelector('.totals__total-cur').innerHTML = Shopify.currency.active;
                } 
            }
          
            //toggle safeguard
            if(checkBox){
              checkBox.addEventListener('click', function(){      
                checkSafeguardStatus(checkBox);
              });
              
            }
          
            //onload check if safeguard checked then update price  
            if(!safeguardInCart){
              checkSafeguardStatus(checkBox);
            }
          
            //remove safeguard
            if(cross){
              cross.addEventListener('click', function(){
                safeguardBox.style.display = "none";
                checkBox.click();
              });
      
            }
          
            
            //question mark hover functionality
            let questionMarkIcon = document.querySelector('.question-mark');
            if(questionMarkIcon){
              questionMarkIcon.addEventListener('mouseover', function(){
                let questionBox = document.querySelector('.question-hover');
                questionBox.style.display = 'block';
              });
              questionMarkIcon.addEventListener('mouseout', function(){
                let questionBox = document.querySelector('.question-hover');
                questionBox.style.display = 'none';
              });
            }
          
            //custom checkout button functionality
            let checkoutBtn = document.querySelector('#CartDrawer-Checkout');
            if(checkoutBtn){
              //remove submit attr
              checkoutBtn.setAttribute('type', 'button');
          
              //add click event and our custom functionality
              checkoutBtn.addEventListener('click', function(){
                let safeguardId = document.querySelector('.checkbox-content input.check-box').getAttribute('data-variant-id');
                // console.log('safeguardId', safeguardId);
                
                if(checkBox.checked == true){
                  
                  //console.log('in if checkout');
                  
                  fetch('/cart.js')
                  .then(res => res.json())
                  .then(data => {
                    console.log('cart data: ', data);
          
                    let cartItems = data.items;
                    let permalinkString = '/cart/';
                    let addSafeguard = true;
                    let directCheckout = false;
                    cartItems.forEach(function(itemEle){
                      let prod_title = itemEle.title;
                      let prod_variant_id = itemEle.id;
                      let prod_qty = itemEle.quantity;
                      if(prod_title.includes('Safeguard')){
                        addSafeguard = false;
                        //console.log('addSafeguard 1', addSafeguard);
                        directCheckout = true;
                      }else{
                        permalinkString += `${prod_variant_id}:${prod_qty},`;
                      }
                    });
                    
                    if(addSafeguard){            
                      //console.log('addSafeguard 2', addSafeguard);
                      permalinkString += `${safeguardId}:1`;
                    }
                    
                    if(directCheckout == false){
                      let finalURL = `${permalinkString}`;          
                      //console.log('finalURL', finalURL);            
                      location.href = finalURL;            
                    }else{
                      location.href = '/checkout';
                    }
                    
                  });
                  
                }else{
                  //console.log('in else checkout');
                  
                  fetch('/cart.js')
                  .then(res => res.json())
                  .then(data => {
                    //console.log('cart data: ', data);
          
                    let cartItems = data.items;
                    let permalinkString = '/cart/';
                    let addSafeguard = false;
                    cartItems.forEach(function(itemEle){
                      let prod_title = itemEle.title;
                      let prod_variant_id = itemEle.id;
                      let prod_qty = itemEle.quantity;
                      if(prod_title.includes('Safeguard')){
                        addSafeguard = false;
                        //console.log('addSafeguard 11', addSafeguard);
                      }
                      if(!prod_title.includes('Safeguard')){
                        permalinkString += `${prod_variant_id}:${prod_qty},`;
                      }
                    });
                    
                    if(addSafeguard){            
                      //console.log('addSafeguard 22', addSafeguard);
                      permalinkString += `${safeguardId}:1`;
                    }
                    
                    let finalURL = `${permalinkString}`;          
                    //console.log('finalURL', finalURL);
          
                    location.href = finalURL;
                    
                  });
                  
                }
              });
              
              
            }
          
          
            }, 1000);
            
          // }, false);//DOMContentLoaded ends
          // custom safegaurd functionality code ends

    
  }//renderContents ends

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
